import React, { useEffect, useState } from "react";

import cross from "assets/images/adduser/cross.svg";
import crossDark from "assets/images/adduser/crossDark.svg";

import Button from "components/Button/index";

import "./userModal.scss";
import useTheme from "hooks/observer";
// import { useNavigate } from "react-router-dom";
// import init, { IzWasm } from "wasm/izwasm.js";
const UserModal = ({
  title,
  description,
  formData,
  setFormData,
  setShowModal,
  btnText = "Add User",
  onSubmit = () => {},
  userlist,
  setUserlist,
  init,
  readonly = false
}) => {
  // const navigate = useNavigate();
  const theme = useTheme();
  const crossIcon = theme === "light" ? cross : crossDark;
  const [errors, setErrors] = useState({});

  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => (document.body.style.overflow = "auto");
  }, []);

  const validate = (name, value, type) => {
    let error = "";
    if (name === "name") {
      const nameRegex = /^[a-zA-Z ]{2,30}$/;
      if (!value) {
        error = "Name is required";
      } else if (!nameRegex.test(value)) {
        error =
          "Name must be 2-30 characters and contain only letters and spaces";
      }
    }

    if (name === "email") {
      if (!value) {
        error = "Email is required";
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          error = "Invalid email format";
        }
      }
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const error = validate(name, value);
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: error });
  };
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const nameError = validate("name", formData.name);
    const emailError = validate("email", formData.email);
    // await init();
    // const wasmInstance = new IzWasm("wss://127.0.0.1:5577/");
    try {
      setLoading(true);
      if (!nameError && !emailError) {
        if (!init) {
          onSubmit();
          // setUserlist(updatedUsers);
          setFormData({ name: "", email: "" });
          setShowModal(false);
        } else {
          let existingUsers = [];
          try {
            existingUsers = JSON.parse(sessionStorage.getItem("users")) || [];
          } catch (error) {
            console.error("Error parsing sessionStorage data:", error);
            existingUsers = [];
          }

          const updatedUsers = [...existingUsers, formData];
          sessionStorage.setItem("users", JSON.stringify(updatedUsers));
          setUserlist(updatedUsers);
          setFormData({ name: "", email: "" });
          setShowModal(false);
        }
      } else {
        setErrors({ name: nameError, email: emailError });
      }
    } catch (error) {
      setLoading(false);
      
    }
  };

  const checkFormValidity = () => {
    return (
      Object.values(errors).every((error) => !error) &&
      Object.values(formData).every((value) => String(value)?.trim() !== "")
    );
  };

  useEffect(() => {
    setIsFormValid(checkFormValidity());
  }, [formData, errors]);
  return (
    <div className="modalOverlay">
      <div className="modalContainerr">
        <img
          src={crossIcon}
          alt="close"
          className="cross"
          onClick={() => {
            setShowModal(false);
          }}
        />
        <div className="modalHeader">
          <h2 className="modalTitle">{title}</h2>
          <p className="modalDescription">{description}</p>
        </div>
        <div className="modalBody">
          <div className="signUpDataContents">
            <form className="form" onSubmit={handleSubmit}>
              <div className="formData">
                <div className="field">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Your Name"
                    onChange={handleChange}
                    maxLength={30}
                    value={formData?.name}
                  />
                  {errors.name && <p className="errorMsg">{errors.name}</p>}
                </div>
                <div className="field">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="you@company.com"
                    onChange={handleChange}
                    value={formData?.email}
                    readOnly={readonly}
                  />
                  {errors.email && <p className="errorMsg">{errors.email}</p>}
                </div>
              </div>
              <div className="startButtonContainer">
                {/* <button
                  type="submit"
                  className={`startButton ${isFormValid ? "enabled" : "disabled"}`}
                  disabled={!isFormValid}
                >
                  Add User
                </button> */}
                <Button loading={loading} title={btnText} type="violet" disabled={!isFormValid} />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserModal;
